module.exports = __webpack_public_path__ + "img/icon_search_helmet_alarmstrong.37449ae9.png";